module.exports = __webpack_public_path__ + "img/qz-windows-add-certificate.9d9b6ca1.png";